import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromReservation } from 'store/selectors';

import { FilterControl } from 'components';

import { getNumberOfChildren } from 'helpers/reservation';

const FilterControlContainer = props => <FilterControl {...props} />;

FilterControlContainer.propTypes = {
  filter: PropTypes.string.isRequired,
  defaultFilter: PropTypes.string,
};

const mapStateToProps = (state, { departureId }) => {
  const guests = fromReservation.getGuestsByDeparture(state, departureId).map(id => fromReservation.getGuest(state, id));

  return {
    showCategoriesFilter: getNumberOfChildren(guests) > 0,
  };
};

export default connect(mapStateToProps)(FilterControlContainer);



// WEBPACK FOOTER //
// ./src/containers/FilterControl.js